<script setup lang="ts">
</script>
<template>
  <!-- Overlay -->
  <div
    class="overlay z-51 fixed inset-0 bg-black/50 opacity-0 invisible transition-all duration-600 ease-in-out pointer-events-none z-40"></div>
</template>